import { SectionShell } from "@/components/design-system/SectionShell";
import { Banner } from "@/components/blocks/Banner";

const code = `import { Banner } from "@/components/blocks/Banner";

<Banner onDismiss={() => setVisible(false)} dismissLabel="Dismiss notice">
  <strong>You're using the beta.</strong> Features are still changing.
</Banner>`;

export function BannerSection() {
  return (
    <SectionShell
      id="banner"
      title="Banner"
      description={
        <>
          A notice at the top of a page, built on <code>.callout</code> with
          the accent tint. Add <code>onDismiss</code> to show a close button.
        </>
      }
      whenToUse={
        <ul>
          <li>Site-wide notices that apply to the whole page, such as the beta notice.</li>
          <li>Announcements people can dismiss and not see again.</li>
        </ul>
      }
      whenNotToUse={
        <ul>
          <li>Feedback after an action — use a toast.</li>
          <li>Errors in a form — show them next to the field.</li>
          <li>A tip inside page content — use a plain <code>.callout</code>.</li>
        </ul>
      }
      preview={
        <Banner onDismiss={() => {}} dismissLabel="Dismiss notice">
          <strong>You&apos;re using the beta.</strong> Features are still changing.
        </Banner>
      }
      code={code}
      options={
        <ul className="list-disc pl-5">
          <li>
            Remember a dismissal in <code>localStorage</code> and read it in{" "}
            <code>useEffect</code>, so server and client render the same
            markup. See <code>BetaBanner</code>.
          </li>
        </ul>
      }
    />
  );
}
